export const operationTypeEnum = {
    NO_OPS: "NO_OPS",

    //password reset page
    RESET_ACCOUNT_PASSWORD: "RESET_ACCOUNT_PASSWORD"
};